import * as React from 'react';
import { Input, TextArea } from '~/UI/Input';

import styles from './styles.less';

export const TextAreaRow: React.FunctionComponent<
	React.PropsWithChildren<{
		disabled: boolean;
		value: string;
		small?: boolean;
		onChange(value: string): void;
	}>
> = ({ children, disabled, value, small = false, onChange }) => {
	return (
		<label className={styles.label}>
			<span className={styles.labelText}>{children}</span>
			{small ? (
				<Input
					disabled={disabled}
					value={value}
					onChange={(event) => {
						onChange(event.currentTarget.value);
					}}
				/>
			) : (
				<TextArea
					cols={140}
					disabled={disabled}
					rows={5}
					value={value}
					onChange={(event) => {
						onChange(event.currentTarget.value);
					}}
				/>
			)}
		</label>
	);
};
